import React from 'react'
import {IconButton, makeStyles, Typography} from '@material-ui/core'
import CloseIcon from '@mui/icons-material/Close';
import { FormControlLabel, Radio, RadioGroup, TextField } from '@material-ui/core'
import { ReactComponent as RadioInvertedCheck } from '../../../../../assests/icons/RadioInvertedCheck.svg'

const useStyles = makeStyles(() => ({
    existPatient:{
        background:'#5571C6', 
        width:"100%", 
        paddingTop:"2px"
    },
    existPatientCheck:{
        display: "flex",
        alignItems:'center', 
        alignContent: 'center', 
        justifyContent:"space-between", 
        // cursor:'pointer'
    },
    existPatientHeader1:{
        fontSize: '24px', 
        fontFamily: 'Inter',
        color: '#fff',
        padding :"8px 10px",
        fontWeight: "450",
        
    },
    reasonForVisit:{
        resize: 'none',
        display: 'inline-flex',
        height: '312px',
        alignItems: 'center',
        flexShrink: '0',
        borderRadius: '5px',
        border: '1px solid #d0d0d0',
        background: '#fff',
        width: '99%',
        // color: '#667689',
        fontFamily: 'Inter',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: '500',
        padding: '10px 0px 10px 10px',
        '@media (max-width: 768px)': {
            width: '96%',
            padding: '5px',
        },

    },
    container: {
        width: '100%',
    },
}))
const IntakeNewModal = ({intakeValues, intakeSetValues, setOpenIntakeModal, setValue}) => {
    const classes = useStyles()
    const renderError = (fieldName) => {
        if (!intakeValues?.errors[fieldName] || !intakeValues?.touched[fieldName]) return <></>
        return (
            intakeValues?.errors[fieldName] &&
            intakeValues?.touched[fieldName] && (
                <Typography style={{ color: 'red', marginLeft: 20 }}>
                    {intakeValues?.errors[fieldName]}
                </Typography>
            )
        )
    }

    return (
        <>
            <div>
                <div className={classes.existPatient}>
                    <div className={classes.existPatientCheck} style={{ padding: '0px 8px' }}>
                        <Typography className={classes.existPatientHeader1}>
                            Intake Form (1 of 1)
                        </Typography>
                        <IconButton onClick={()=>{setOpenIntakeModal(false), intakeValues.resetForm(),setValue()}}>
                            <CloseIcon style={{color: '#fff'}}/>
                        </IconButton>
                    </div>
                </div>
                <div className="body">
                        <div>
                            <div className="card_content" style={{padding:'15px'}}>
                                <div className="intake_form_container intakeformBox">
                                    <div className="question">
                                        <span style={{ display: 'flex', gap: 7 }}>
                                            <Typography className="question_text">
                                                Is patient a minor?
                                                <span className="required"></span>
                                            </Typography>
                                        </span>
                                        <RadioGroup
                                            row
                                            value={intakeValues?.values?.minor}
                                            onChange={(event) =>
                                                intakeSetValues('minor', event.target.value)
                                            }
                                            className="intake_form_radio_group"
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            name="radio-buttons-group">
                                            <FormControlLabel
                                                className="cstm_label"
                                                value="yes"
                                                control={
                                                    <Radio checkedIcon={<RadioInvertedCheck />} />
                                                }
                                                label="Yes"
                                            />
                                            <FormControlLabel
                                                className="cstm_label"
                                                value="no"
                                                control={
                                                    <Radio checkedIcon={<RadioInvertedCheck />} />
                                                }
                                                label="No"
                                            />
                                        </RadioGroup>
                                        {renderError('minor')}
                                    </div>
                                    <div className="question">
                                        <span style={{ display: 'flex', gap: 7 }}>
                                            <Typography className="question_text">
                                                Do you have any current or pending legal issues or are being advised by a court judge, parole officer, or CPS to seek mental health care or assessment?
                                                <span className="required"></span>
                                            </Typography>
                                        </span>
                                        <RadioGroup
                                            row
                                            value={intakeValues?.values?.careOrAssessment}
                                            onChange={(event) =>
                                                intakeSetValues('careOrAssessment', event.target.value)
                                            }
                                            className="intake_form_radio_group"
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            name="radio-buttons-group">
                                            <FormControlLabel
                                                className="cstm_label"
                                                value="yes"
                                                control={
                                                    <Radio checkedIcon={<RadioInvertedCheck />} />
                                                }
                                                label="Yes"
                                            />
                                            <FormControlLabel
                                                className="cstm_label"
                                                value="no"
                                                control={
                                                    <Radio checkedIcon={<RadioInvertedCheck />} />
                                                }
                                                label="No"
                                            />
                                        </RadioGroup>
                                        {renderError('careOrAssessment')}
                                    </div>
                                    <div className="question">
                                        <span style={{ display: 'flex', gap: 7 }}>
                                            <Typography className="question_text">
                                                Please select if you have ever experienced or suffered from any of the following in the past or present? 
                                                <br/>
                                            <Typography className="question_text">
                                                (check that applies)
                                            </Typography>
                                            </Typography>
                                           
                                        </span>
                                    </div>
                                    <div className="question">
                                        <span style={{ display: 'flex', gap: 7 }}>
                                            <Typography className="question_text">
                                                Have you had thoughts of harming yourself?
                                                <span className="required"></span>
                                            </Typography>
                                        </span>
                                        {/* <div className="answer_boxes">
                                            <CheckboxOption
                                                option={{
                                                    label: 'Past',
                                                    value: true,
                                                }}
                                                // checked={values.harmingOthers.past}
                                                // onChange={(event) => {
                                                //     setValues(
                                                //         'harmingOthers.past',
                                                //         event.target.checked,
                                                //     )
                                                // }}
                                            />
                                            <CheckboxOption
                                                option={{
                                                    label: 'Present',
                                                    value: false,
                                                }}
                                                // checked={values.harmingOthers.present}
                                                // onChange={(event) => {
                                                //     setValues(
                                                //         'harmingOthers.present',
                                                //         event.target.checked,
                                                //     )
                                                // }}
                                            />
                                            <CheckboxOption
                                                option={{
                                                    label: 'Never',
                                                    value: false,
                                                }}
                                                // checked={values.harmingOthers.never}
                                                // onChange={(event) => {
                                                //     setValues(
                                                //         'harmingOthers.never',
                                                //         event.target.checked,
                                                //     )
                                                // }}
                                            />
                                        </div> */}
                                        <RadioGroup
                                            row
                                            value={intakeValues?.values?.harmingYourself}
                                            onChange={(event) =>
                                                intakeSetValues('harmingYourself', event.target.value)
                                            }
                                            className="intake_form_radio_group"
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            name="radio-buttons-group">
                                            <FormControlLabel
                                                className="cstm_label"
                                                value="past"
                                                control={
                                                    <Radio checkedIcon={<RadioInvertedCheck />} />
                                                }
                                                label="Past"
                                            />
                                            <FormControlLabel
                                                className="cstm_label"
                                                value="current"
                                                control={
                                                    <Radio checkedIcon={<RadioInvertedCheck />} />
                                                }
                                                label="Current"
                                            />
                                            <FormControlLabel
                                                className="cstm_label"
                                                value="never"
                                                control={
                                                    <Radio checkedIcon={<RadioInvertedCheck />} />
                                                }
                                                label="Never"
                                            />
                                        </RadioGroup>
                                        {renderError('harmingYourself')}
                                    </div>
                                    <div className="question">
                                        <span style={{ display: 'flex', gap: 7 }}>
                                            <Typography className="question_text">
                                                Have you had thoughts of harming others?
                                                <span className="required"></span>
                                            </Typography>
                                        </span>
                                        <RadioGroup
                                            row
                                            value={intakeValues?.values?.harmingOthers}
                                            onChange={(event) =>
                                                intakeSetValues('harmingOthers', event.target.value)
                                            }
                                            className="intake_form_radio_group"
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            name="radio-buttons-group">
                                            <FormControlLabel
                                                className="cstm_label"
                                                value="past"
                                                control={
                                                    <Radio checkedIcon={<RadioInvertedCheck />} />
                                                }
                                                label="Past"
                                            />
                                            <FormControlLabel
                                                className="cstm_label"
                                                value="current"
                                                control={
                                                    <Radio checkedIcon={<RadioInvertedCheck />} />
                                                }
                                                label="Current"
                                            />
                                            <FormControlLabel
                                                className="cstm_label"
                                                value="never"
                                                control={
                                                    <Radio checkedIcon={<RadioInvertedCheck />} />
                                                }
                                                label="Never"
                                            />
                                        </RadioGroup>
                                        {renderError('harmingOthers')}
                                    </div>
                                    <div className="question">
                                        <span style={{ display: 'flex', gap: 7 }}>
                                            <Typography className="question_text">
                                                Have you struggled with alcohol abuse?
                                                <span className="required"></span>
                                            </Typography>
                                        </span>
                                        <RadioGroup
                                            row
                                            value={intakeValues?.values.alcoholAbuse}
                                            onChange={(event) =>
                                                intakeSetValues('alcoholAbuse', event.target.value)
                                            }
                                            className="intake_form_radio_group"
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            name="radio-buttons-group">
                                            <FormControlLabel
                                                className="cstm_label"
                                                value="past"
                                                control={
                                                    <Radio checkedIcon={<RadioInvertedCheck />} />
                                                }
                                                label="Past"
                                            />
                                            <FormControlLabel
                                                className="cstm_label"
                                                value="current"
                                                control={
                                                    <Radio checkedIcon={<RadioInvertedCheck />} />
                                                }
                                                label="Current"
                                            />
                                            <FormControlLabel
                                                className="cstm_label"
                                                value="never"
                                                control={
                                                    <Radio checkedIcon={<RadioInvertedCheck />} />
                                                }
                                                label="Never"
                                            />
                                        </RadioGroup>
                                        {renderError('alcoholAbuse')}
                                    </div>
                                    <div className="question">
                                        <span style={{ display: 'flex', gap: 7 }}>
                                            <Typography className="question_text">
                                                Have you struggled with substance abuse?
                                                <span className="required"></span>
                                            </Typography>
                                        </span>
                                        <RadioGroup
                                            row
                                            value={intakeValues?.values?.substanceAbuse}
                                            onChange={(event) =>
                                                intakeSetValues('substanceAbuse', event.target.value)
                                            }
                                            className="intake_form_radio_group"
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            name="radio-buttons-group">
                                            <FormControlLabel
                                                className="cstm_label"
                                                value="past"
                                                control={
                                                    <Radio checkedIcon={<RadioInvertedCheck />} />
                                                }
                                                label="Past"
                                            />
                                            <FormControlLabel
                                                className="cstm_label"
                                                value="current"
                                                control={
                                                    <Radio checkedIcon={<RadioInvertedCheck />} />
                                                }
                                                label="Current"
                                            />
                                            <FormControlLabel
                                                className="cstm_label"
                                                value="never"
                                                control={
                                                    <Radio checkedIcon={<RadioInvertedCheck />} />
                                                }
                                                label="Never"
                                            />
                                        </RadioGroup>
                                        {renderError('substanceAbuse')}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </>
    )
}
export default IntakeNewModal